















import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { mapState } from 'vuex'

@Component({
  computed: {
    ...mapState({
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email,
      loginMethod: ({ gamblingContext }: any): boolean => gamblingContext.loginMethod
    })
  }
})

export default class LoginBtn extends Vue {
  @Action('loginUserPassword') loginUserPassword: any

  fullName!: null | string
  email!: null | string

  get logInBtn () {
    return this.fullName && this.email && this.fullName.length > 4 && this.email.length > 5
  }
}
